sap.ui.define(["sap/ui/core/library", 'sap/uxap/BlockBase'], function (coreLibrary, BlockBase) {
	"use strict";

	var ViewType = coreLibrary.mvc.ViewType;

	var PendingRequests = BlockBase.extend("com.reply.leaviosa.blocks.pendingRequests.PendingRequests", {
		metadata: {
			views: {
				Collapsed: {
					viewName: "com.reply.leaviosa.blocks.pendingRequests.PendingRequests",
					type: ViewType.XML
				},
				Expanded: {
					viewName: "com.reply.leaviosa.blocks.pendingRequests.PendingRequests",
					type: ViewType.XML
				}
			}
		}
	});
    
	return PendingRequests;
});